import React from "react";

import { debounce } from "lodash";
import IShortCutKeys from "../../redux/types/IShortCutKeys";
import { IParameterData } from "../types/IParameterData";

interface ISettingsPageEventListenerComponentEventListenerProps {
    saveMethod: () => void;
    shortCutKeys: IShortCutKeys[];
    data: IParameterData[],
}

const SettingsPageEventListener: React.FC<ISettingsPageEventListenerComponentEventListenerProps> = ({
    data,
    saveMethod,
    shortCutKeys,
}) => {
    const [keysPressed, setKeysPressed] = React.useState({});

    const areCorrectKeysPressed = (actionCode, pressedKeys) => {
            if (!shortCutKeys || !pressedKeys) return false;
        
          
            const shortCutKeysString = shortCutKeys && shortCutKeys.find((key) => key.actionCode === actionCode)?.key;
        
            if (!shortCutKeysString) return false;
        
            const shortCutKeysArray = shortCutKeysString.split(',');
            const filteredPressedKeys = shortCutKeysArray.filter((key) => pressedKeys[key]);
        
            return filteredPressedKeys.length === shortCutKeysArray.length;
    };

    const setKeyState = (event, state) => {
        setKeysPressed((prevState) => {
            const newState = {...prevState};
            newState[event.key] = state;
            saveKeyListener(event, newState);
            return newState});
     }

    React.useEffect(() => {
        window.addEventListener('keydown', (event) => {
            setKeyState(event, true)
         });
           window.addEventListener('keyup', (event) => {
            setKeyState(event, false)
          });


          return () => {
            setKeysPressed({});
            window.addEventListener('keydown', (event) => {
                setKeyState(event, true)
             });
            window.removeEventListener('keyup', (event) => {
                setKeyState(event, false)
             });
          }
    }, [shortCutKeys, data]);
    const saveKeyListener = (e, pressedKeys) => {
        if (areCorrectKeysPressed("SAVE_DATA", pressedKeys)) {
            e.preventDefault();
            console.log("Save data triggered by shortcut keys", data);
            data && saveMethod()
        }
        }

    return <></>
    
}

export default SettingsPageEventListener;
